import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { questionnaireKeys } from './questionnaireKeys';

export function useDeleteQuestionnaire() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (questionnaireId: string) =>
      apiClient
        .delete(`api/v1/t/${tenantId}/questionnaires/${questionnaireId}`)
        .then(() => undefined),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: questionnaireKeys.lists() });
    },
  });
}
